import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { downloadFile } from 'utils/download-file';
import { useObraDetailsDispatch } from './obra-details-context';
import { ACTION_TYPES } from './obra-details-reducer';

export const useObraDetailsController = () => {
  const dispatch = useObraDetailsDispatch();

  const loadObraDetails = useCallback(async (id: number) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      dispatch({ type: ACTION_TYPES.setError, payload: null });

      const response = await MunicipalPortalAAppService.getObra(id);

      dispatch({ type: ACTION_TYPES.setObraDetails, payload: response });
    } catch (error) {
      console.error('Error loading obra details:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes da obra' });
      dispatch({ type: ACTION_TYPES.setObraDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  const clearObraDetails = useCallback(() => {
    dispatch({ type: ACTION_TYPES.setObraDetails, payload: null });
    dispatch({ type: ACTION_TYPES.setError, payload: null });
  }, [dispatch]);

  const exportObraDetail = useCallback(async (id: number, format: string) => {
    const file = await MunicipalPortalAAppService.exportObraDetail(id, format);
    downloadFile(file);
  }, []);

  return {
    loadObraDetails,
    clearObraDetails,
    exportObraDetail,
  };
};
